import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    verificationRejectedTitle: {
        id: 'migration.modal.verification_rejected.title',
        defaultMessage: 'We are verifying your identity',
    },
    verificationRejectedSubtitle: {
        id: 'migration.modal.verification_rejected.subtitle',
        defaultMessage: 'It can take some time. Please come back later',
    },
    supportButtonText: {
        id: 'migration.modal.verification_rejected_contact_support_button.text',
        defaultMessage: 'Contact support',
    },
    signOutButtonText: {
        id: 'migration.modal.verification_rejected_sign_out_button.text',
        defaultMessage: 'Sign out',
    },
})
